import { useState, useEffect, ReactNode } from 'react';

import AntCheckableTag, {
  CheckableTagProps as AntCheckableTagProps,
} from 'antd/lib/tag/CheckableTag';
import { useSelector } from 'react-redux';
import { T } from 'react-translator-component';
import styled from 'styled-components';

import { isProUser } from '../../utils/isProUser/isProUser';
import { COLORS } from '../../utils/theme/colors';
import Operations from '../organisms/Operations';
import OperationsChargingProfiles from '../organisms/OperationsChargingProfiles';
import OperationsTasks from '../organisms/OperationsTasks';

interface CheckableTagProps extends AntCheckableTagProps {
  children: ReactNode;
}

const CheckableTag = (props: CheckableTagProps) => (
  <AntCheckableTag {...props} />
);

const OperationsPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  h1 {
    font-size: 24px;
  }

  h2 {
    font-size: 18px;
  }

  .box_title {
    color: ${COLORS.primary};
  }

  .box_title_red {
    color: red;
  }

  .box_title_green {
    color: green;
  }
`;

const PageTitle = styled.h1`
  margin: 20px 10px 0 2%;
  font-size: 21px;
  font-weight: normal;
  font-family: 'Roboto';
  color: #777;
`;

const OperationsSelectWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
`;

const OperationsPage = () => {
  const [selectedTag, setSelectedTag] = useState<any>();

  const routes = useSelector((state: any) => state.user.routes);

  useEffect(() => {
    (async () => {
      if (routes) {
        if (routes.find(({ path }) => path === '/operations/v15')) {
          setSelectedTag('v1.5');
        } else if (routes.find(({ path }) => path === '/operations/v16')) {
          setSelectedTag('v1.6');
        } else if (routes.find(({ path }) => path === '/operations/tasks')) {
          setSelectedTag('tasks');
        } else if (
          routes.find(({ path }) => path === '/operations/charging_profile')
        ) {
          setSelectedTag('charging_profiles');
        }
      }

      if (!isProUser()) {
        setSelectedTag('v1.6');
      }
    })();
  }, [routes]);

  const handleChange = (tag, checked) => {
    const nextSelectedTag = checked ? tag : 0;
    setSelectedTag(nextSelectedTag);
  };
  return (
    <>
      <OperationsSelectWrapper>
        <PageTitle>{T('Operations')}</PageTitle>
        {isProUser() &&
        routes &&
        routes.find(({ path }) => path === '/operations/v15') ? (
          <CheckableTag
            key={'v1.5'}
            checked={selectedTag === 'v1.5'}
            onChange={(checked) => handleChange('v1.5', checked)}
          >
            v1.5
          </CheckableTag>
        ) : null}

        {routes && routes.find(({ path }) => path === '/operations/v16') ? (
          <CheckableTag
            key={'v1.6'}
            checked={selectedTag === 'v1.6'}
            onChange={(checked) => handleChange('v1.6', checked)}
          >
            v1.6
          </CheckableTag>
        ) : null}

        {isProUser() &&
        routes &&
        routes.find(({ path }) => path === '/operations/tasks') ? (
          <CheckableTag
            key={'tasks'}
            checked={selectedTag === 'tasks'}
            onChange={(checked) => handleChange('tasks', checked)}
          >
            {T('Tasks')}
          </CheckableTag>
        ) : null}

        {isProUser() &&
        routes &&
        routes.find(({ path }) => path === '/operations/charging_profile') ? (
          <CheckableTag
            key={'charging_profiles'}
            checked={selectedTag === 'charging_profiles'}
            onChange={(checked) => handleChange('charging_profiles', checked)}
          >
            {T('Charging Profiles')}
          </CheckableTag>
        ) : null}
      </OperationsSelectWrapper>
      <OperationsPageWrapper>
        {(selectedTag === 'v1.5' || selectedTag === 'v1.6') && (
          <Operations mode={selectedTag} />
        )}
        {selectedTag === 'tasks' && <OperationsTasks mode={selectedTag} />}
        {selectedTag === 'charging_profiles' && (
          <OperationsChargingProfiles mode={selectedTag} />
        )}
      </OperationsPageWrapper>
    </>
  );
};

export default OperationsPage;
